// extracted by mini-css-extract-plugin
export default {"wrapper":"MainChart_wrapper__t7xjh"};